module.exports = __webpack_public_path__ + "static/scale-model-of-dc-ghosts-in-washington-d.c.-724259f559b34f4b7e56d1114ca19573.png";